import styles from "./styles.module.scss";
import AppContext from "../../hooks/appContext";
import { useContext, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
// import CloseIcon from '@material-ui/icons/Close';

const ButtonSearch = (props) => {
  const {
    filterParams,
    setFilterParams,
  } = useContext(AppContext);

  const [searchPhrase, setSearchPhrase] = useState(filterParams?.searchQuery);

  const handleSearch = () => {
    setFilterParams({ ...filterParams, searchQuery: searchPhrase })
  }

  const handleSearchCancel = () => {
    setFilterParams({ ...filterParams, searchQuery: "" })
  }

  return (
    <>
      <div className={styles['btn-input-wrapper']}>
        <input
          className={styles['btn-input']}
          onChange={(e) => setSearchPhrase(e.target.value)}
          value={searchPhrase}
          placeholder="Search this store..."
          readOnly= {filterParams?.searchQuery}
        />

        {
          filterParams?.searchQuery ? 
          <div className={styles['search-close-btn']} onClick={() => handleSearchCancel()}> <CloseIcon /> </div>
          :
          <div className={styles['input-btn']} onClick={() => handleSearch()}>Search</div>
        }
      </div>
    </>
  )
}

export default ButtonSearch;